export async function updateIntegrationsData({
  userId,
  integrationName,
  userOrigin,
}: {
  userId: number;
  integrationName: string;
  userOrigin?: string;
}): Promise<Response> {
  try {
    const response = await fetch('/api/proxy/v3/users/updateIntegrationsData', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        userId,
        integrationName,
        userOrigin,
      }),
    });

    if (response.ok) return response.json();
    throw new Error('Unable to persist user integrations data');
  } catch (err) {
    throw new Error(err.message);
  }
}
